import { Component, type ReactNode } from 'react';

interface State {
  err: Error | null;
}

interface Props {
  children: ReactNode;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { err: null };

  static getDerivedStateFromError(err: Error): State {
    return { err };
  }

  componentDidCatch(err: Error) {
    console.error('ErrorBoundary caught:', err);
  }

  handleReset = () => {
    localStorage.removeItem('codeframe.doc.v1');
    location.reload();
  };

  render() {
    if (!this.state.err) {
      return this.props.children;
    }

    return (
      <div className="p-6 font-mono text-sm bg-white h-screen w-screen flex flex-col">
        <h2 className="text-base mb-2 font-bold">codeframe crashed</h2>
        <pre className="text-xs whitespace-pre-wrap overflow-auto flex-1 border border-neutral-300 p-3 mb-3 bg-neutral-50">
          {this.state.err.stack ?? this.state.err.message}
        </pre>
        <button
          onClick={this.handleReset}
          className="px-3 py-2 border border-neutral-300 rounded hover:bg-neutral-100 transition-colors w-fit"
        >
          reset canvas + reload
        </button>
      </div>
    );
  }
}
